export default "__VITE_ASSET__7dbae96f__"